export default __webpack_public_path__ + "static/media/forestly-expl-04b_EN.76c11ca9.png";